// extracted by mini-css-extract-plugin
export default {"exchangeBox":"index_exchangeBox__Yik9w","icon__notice":"index_icon__notice__h0iqE","content":"index_content__MaWrz","icon__close":"index_icon__close__L+pYi"};